// Some math operations are quite expensive to compute many times over. These constants optimize this by only computing once
export const MATH_2_TO_THE_POWER_OF_7 = Math.pow(2, 7);
export const MATH_2_TO_THE_POWER_OF_8 = Math.pow(2, 8);
export const MATH_2_TO_THE_POWER_OF_15 = Math.pow(2, 15);
export const MATH_2_TO_THE_POWER_OF_16 = Math.pow(2, 16);
export const MATH_2_TO_THE_POWER_OF_31 = Math.pow(2, 31);
export const MATH_2_TO_THE_POWER_OF_32 = Math.pow(2, 32);
export const MATH_2_TO_THE_POWER_OF_32_MINUS_1 = MATH_2_TO_THE_POWER_OF_32 - 1;
export const MATH_2_TO_THE_POWER_OF_53 = Math.pow(2, 53);
export const MATH_2_TO_THE_POWER_OF_53_MINUS_1 = MATH_2_TO_THE_POWER_OF_53 - 1;
